<div class="d-flex flex-column justify-content-center align-items-center qr">
  <qrcode [elementType]="'canvas'" [qrdata]="value" [width]="width" ></qrcode> 
  <span>
    <!-- {{ value }} -->
  </span>
</div>